import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';



export default function SliderModal(param) {

    return(
        <div className="modal fade" id="sliderModal" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl  modal-dialog-centered">
                <div className="modal-content">
                
                    <div className="modal-header">
                        <h4 className="modal-title">슬라이드 미리보기</h4>
                        <button type="button" className="close" data-dismiss="modal">&times;</button>
                    </div>
                    
                    <div className="modal-body">
                        <Slider >
                            {param.sliderList.map((item, index) => (
                                <div
                                    key={index}
                                    // style={{ background: `url('${item.imageUrl}') no-repeat center center / 100%` }}
                                >   <img src={item.imageUrl} style={{ width: `auto`, height: `100%`, display: `block`, marginLeft: `auto`, marginRight: `auto` }}></img> 
                                    {/* <div className="center">
                                        
                                        <h1>{item.title}</h1>
                                        <p>{item.content}</p>
                                    </div> */}
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
}

SliderModal.propTypes = {
    data: PropTypes.any,
    callbackMessage: PropTypes.any
  };